export default {
    getCountries(state, payload) {
        state.countries = payload
    }
}


// WEBPACK FOOTER //
// ./src/store/_mutations.js